import React from "react";
import '../App.css';

const About = () =>{
    return (
        <div>
            {/*<!-- About Section -->*/}
            <section id="about" className="section">
                <div className="about-content">
                    <div className="about-header">
                        <h2>Discover Transparency LED</h2>
                        <p>A revolutionary way to showcase your visual content with stunning light weight & slim LED screen</p>
                    </div>
                    
                    <div className="about-main">
                        <div className="about-visual">
                            <div className="showcase-display">
                                <div className="showcase-main">
                                    <div className="corner-decoration top-left"></div>
                                    <div className="corner-decoration bottom-right"></div>
                                    {
                                        /*
                                        <div className="showcase-logo">
                                            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="10" y="25" width="15" height="50" fill="white" transform="rotate(-15 17.5 50)" opacity="0.9" />
                                                <rect x="35" y="15" width="15" height="70" fill="white" />
                                                <rect x="60" y="25" width="15" height="50" fill="white" transform="rotate(15 67.5 50)" opacity="0.9" />
                                                <circle cx="50" cy="50" r="45" fill="none" stroke="white" stroke-width="2" opacity="0.3" />
                                            </svg>
                                        </div>
                                        */
                                    }
                                    <div className="showcase-logo">
                                        <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="60" cy="60" r="55" fill="none" stroke="#00FFFF" stroke-width="2" opacity="0.4" />
                                            <rect x="30" y="30" width="15" height="60" fill="#00FFFF" rx="2" />
                                            <rect x="45" y="30" width="30" height="15" fill="#00FFFF" rx="2" />
                                            <rect x="45" y="75" width="30" height="15" fill="#00FFFF" rx="2" />
                                            <rect x="75" y="45" width="15" height="30" fill="#00FFFF" rx="2" />

                                            <rect x="70" y="70" width="10" height="2" fill="#00FFFF" transform="rotate(45 75 75)" />

                                            <circle cx="20" cy="20" r="1.5" fill="#00FFFF" />
                                            <circle cx="100" cy="20" r="1.5" fill="#00FFFF" />
                                            <circle cx="20" cy="100" r="1.5" fill="#00FFFF" />
                                            <circle cx="100" cy="100" r="1.5" fill="#00FFFF" />

                                            <text x="60" y="110" font-size="10" text-anchor="middle" fill="#00FFFF" font-family="Arial, sans-serif">
                                                Q-RUNNERS LED
                                            </text>
                                        </svg>
                                    </div>

                                    <h3 className="showcase-title">Q-Runers</h3>
                                    <p className="showcase-subtitle">Transform your image galleries into immersive LED experiences</p>
                                    {
                                        /*
                                    <div className="showcase-badges">
                                        <a href="https://developer.mozilla.org/en-US/docs/Web/HTML" target="_blank" rel="noopener noreferrer" className="badge">HTML5</a>
                                        <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank" rel="noopener noreferrer" className="badge">CSS3</a>
                                        <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noopener noreferrer" className="badge">JavaScript</a>
                                        <a href="https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Responsive_Design" target="_blank" rel="noopener noreferrer" className="badge">Responsive</a>
                                    </div>
                                    */
                                    }
                                </div>
                            </div>
                        </div>
                        
                        <div className="about-info">
                            <h3>Elevate Your Gallery Experience</h3>
                            <p>Transform the way you present images and content with our cutting-edge LED technology. Create immersive, interactive galleries and content that captivate your audience and leave a lasting impression.</p>
                            <p>Whether you're showcasing portfolio pieces, product images, or creating an interactive story, our LED screen brings your content to life with fluid animations and intuitive controls.</p>
                            
                            <ul className="feature-list">
                                <li>High transparency to allow natural light to pass while displaying vivd content</li>
                                <li>Ultra-thin,flexible LED film, and easy to install on glass surface</li>
                                <li>Consume significantly less power than traditional LED walls</li>
                                <li>Easy maintenance with module panels</li>
                                <li>Can be curved, folded for custom installations</li>
                            </ul>
                            
                            <a href="#contact" className="cta-button">
                                Start Your Project
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                    
                    <div className="stats-section">
                        <div className="stat-item">
                            <div className="stat-number">95%</div>
                            <div className="stat-label">High Transparency</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Lightweight & Slim</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">LED</div>
                            <div className="stat-label">Visual Effects</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">∞</div>
                            <div className="stat-label">Customization</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;